const makeRequest = (context, url, nodeName) => {
  context.$http.get(url)
    .then(function (response) {
      context[nodeName] = response.data
    })
}

const basicPath = 'public_access/structured_data'

export default {
  methods: {
    loadEventStructuredData (eventId = '') {
      makeRequest(this,
        `${basicPath}/${eventId}?object=event`,
        'eventStructuredData')
    },
    loadCustomEventStructuredData (queryString = '') {
      makeRequest(this,
        `${basicPath}?${queryString}&object=event`,
        'eventStructuredData')
    },
    loadGiftCardStructuredData (giftCardId = '') {
      makeRequest(this,
        `${basicPath}/${giftCardId}?object=gift_card`,
        'giftCardStructuredData')
    },
    loadCustomGiftCardStructuredData (queryString = '') {
      makeRequest(this,
        `${basicPath}?${queryString}&object=gift_card`,
        'giftCardStructuredData')
    }
  }
}
